module.exports = __webpack_public_path__ + "img/userD05.86bf18ed.jpg";